import { useLocation } from 'react-router';
import { useAsync } from 'react-use';

import { Size } from '@material-ui/core';

import { TomtomLabApi } from '../../api';
import { Idea, Status } from '../../types';
import { parseTomtomLabResponse } from '../../util/parseMethods';

export const useIdea = (
  tomtomLabApi: TomtomLabApi,
): { idea: Idea | null | undefined } => {
  const location = useLocation();
  const paths = location.pathname.split('/');
  const ideaId = Number(paths[paths.length - 1]);

  const { value } = useAsync(async () => {
    if (ideaId && !isNaN(ideaId)) {
      const response = await tomtomLabApi.getIdeaById(ideaId);

      if (response) {
        const parsedIdea = await parseTomtomLabResponse(response);
        const idea = {
          id: parsedIdea?.id ?? 0,
          title: parsedIdea?.title ?? '',
          description: parsedIdea?.description ?? '',
          status: parsedIdea?.status ?? ('draft' as Status),
          docs: parsedIdea?.docs ?? '',
          membersCount: parsedIdea?.membersCount ?? 0,
          size: parsedIdea?.size ?? ('small' as Size),
          responsible: parsedIdea?.responsible ?? '',
          summary: parsedIdea?.summary ?? '',
          solution: parsedIdea?.solution ?? '',
          eventId: parsedIdea?.eventId ?? 0,
        };
        return idea;
      }
    }
    return null;
  });

  return { idea: value };
};
